import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _get from "lodash/get";
import _capitalize from "lodash/capitalize";
import "core-js/modules/es6.array.map.js";

/**
 * @module
 *
 * @description Mortgage utils
 */
import { MORTGAGES_LOAN_TYPE_LABELS, MORTGAGES_LOAN_PRODUCT_LABELS, MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS } from '../../constants';
import { getFeaturedLoanAttributes, getLoanProducts, getLoanTypes, getNationalOrRegional } from '../../selectors/mortgages';
/**
 * Returns the lender loan product labels.
 * @deprecated - Use `getLoanTypeAndProductLabels`
 *
 * @param {Object} wpLenderObject - The WordPress lender entity
 * @return {Array} - The array of loan product labels
 */

export var getLoanProductLabels = function getLoanProductLabels(wpLenderObject) {
  var loanProducts = getLoanProducts(wpLenderObject);
  return Array.isArray(loanProducts) ? loanProducts.map(function (slug) {
    return MORTGAGES_LOAN_PRODUCT_LABELS[slug];
  }) : [];
};
/**
 * Returns the lender loan type labels.
 * @deprecated - Use `getLoanTypeAndProductLabels`
 *
 * @param {Object} wpLenderObject - The WordPress lender entity
 * @return {Array} - The array of loan type labels
 */

export var getLoanTypeLabels = function getLoanTypeLabels(wpLenderObject) {
  var loanTypes = getLoanTypes(wpLenderObject);
  return Array.isArray(loanTypes) ? loanTypes.map(function (slug) {
    return MORTGAGES_LOAN_TYPE_LABELS[slug];
  }) : [];
};
/**
 * Gather readable representations of loan types and products.
 *
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {Array} - The array of loan type & product labels
 */

export var getLoanTypeAndProductLabels = function getLoanTypeAndProductLabels(marketplaceEntity) {
  var featuredLoanAttributes = getFeaturedLoanAttributes(marketplaceEntity);

  if (featuredLoanAttributes) {
    return featuredLoanAttributes.map(function (attr) {
      return MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS[attr];
    });
  }

  return [].concat(_toConsumableArray(getLoanTypeLabels(marketplaceEntity)), _toConsumableArray(getLoanProductLabels(marketplaceEntity)));
};
/**
 * Get readable representation of coverage area.
 * @param {Object} marketplaceEntity - The marketplace entity
 * @return {String} - The coverage area label.
 */

export var getCoverageAreaLabel = function getCoverageAreaLabel(marketplaceEntity) {
  var coverageArea = getNationalOrRegional(marketplaceEntity);
  return coverageArea && _capitalize(coverageArea);
};
/**
 * Is the entity from Homeownership or Marketplace?
 *
 * @param {Object} entity - The Mortgages entity (from Homeownership or Marketplace).
 * @return {Boolean} - Whether the entity is from Homeownership service?
 */

export var isLegacyHomeownershipEntity = function isLegacyHomeownershipEntity(entity) {
  return _get(entity, 'type') === 'nw_lender';
};